import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Icon } from 'semantic-ui-react';
import { colorsModeUI } from '../../../../../modeUI';
import { SIZE_SMALL } from '../../../../../constants';
import './index.css';

export default class MenuItem extends Component {
  /**
   * Show ui icon
   * Note: the icon used in the main menu header must be small
   * @return object icon
   */
  static showUiIcon(uiIcon, color) {
    return (
      <uiIcon.type {...uiIcon.props} {...{ color }} {...{ size: SIZE_SMALL }} />
    );
  }

  constructor(props) {
    super(props);
    this.styleItem = this.styleItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * On mouse leave
   */
  onMouseLeave() {
    this.setState({ hover: false });
  }

  /**
   * On mouse enter
   */
  onMouseEnter() {
    this.setState({ hover: true });
  }

  /**
   * Style item
   * @param object item
   * @return object styleItem
   */
  styleItem(item) {
    const { mode } = this.props;
    const { hover } = this.state;
    const colors = colorsModeUI(mode);
    const styleItem = { fontWeight: 'normal' };
    if (mode !== null) {
      if (item.disable) {
        styleItem.color = colors.MAIN_MENU_ITEM_DISABLE;
      } else {
        styleItem.color = item.active
          ? colors.MAIN_MENU_ITEM_ACTIVE
          : colors.MAIN_MENU_ITEM_INACTIVE;
        if (hover) {
          styleItem.color = colors.MAIN_MENU_ITEM_ACTIVE;
          styleItem.fontWeight = 'bold';
        }
      }
    }
    return styleItem;
  }

  /**
   * Create menu item
   * Since the items here are vertical, we don't need to remove the label (because mobile version)
   * @param object item
   * @return react component
   */
  createItem() {
    const { item } = this.props;
    let label;
    /* add icon or uiIcon */
    const styleItem = this.styleItem(item);
    if (item.icon || item.uiIcon) {
      if (item.icon) {
        label = (
          <span style={{ fontWeight: styleItem.fontWeight }}>
            <Icon
              name={item.icon}
              size="large"
              style={item.colorIcon ? { color: item.colorIcon } : {}}
            />
            {item.label}
          </span>
        );
      } else {
        label = (
          <span
            style={{ fontWeight: styleItem.fontWeight }}
            className="menu-item-ui-icon"
          >
            {MenuItem.showUiIcon(
              item.uiIcon,
              item.colorIcon ? item.colorIcon : styleItem.color
            )}
            {item.label}
          </span>
        );
      }
    } else {
      label = (
        <span style={{ fontWeight: styleItem.fontWeight }}>{item.label}</span>
      );
    }
    /* add label */
    let itemMenu = (
      <Dropdown.Item
        disabled={item.disable}
        active={item.active}
        style={styleItem}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        {label}
      </Dropdown.Item>
    );

    /* add item */
    if (item.icon) {
      if (item.key) {
        itemMenu = (
          <itemMenu.type {...itemMenu.props} {...{ icon: item.icon }} />
        );
      }
    }

    /* add key */
    if (item.key) {
      itemMenu = (
        <itemMenu.type {...itemMenu.props} {...{ key: item.key.toString() }} />
      );
    }

    /* add the onClick event */
    if (item.onClick && !item.disable) {
      itemMenu = (
        <itemMenu.type {...itemMenu.props} {...{ onClick: item.onClick }} />
      );
    }
    return itemMenu;
  }

  render() {
    return this.createItem();
  }
}

MenuItem.propTypes = {
  item: PropTypes.shape({
    active: PropTypes.bool,
    disable: PropTypes.bool,
    key: PropTypes.string,
    icon: PropTypes.string,
    uiIcon: PropTypes.node,
    colorIcon: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
  }).isRequired,
  mobileVersion: PropTypes.bool,
  mode: PropTypes.string,
};

MenuItem.defaultProps = {
  mobileVersion: false,
  mode: null,
};
